import React, { useState, useEffect } from "react";
import "./Header.css";
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import imageUrl from "./../../assets/logo.jpg";
import babaji from "./../../assets/gurujambheshwar.jpg";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import BaseUrl from "../../base-api";

const Header = (props) => {
  const navigate = useNavigate();
  const tokenKey = "$3ingT0k3n";
  const [jwtToken, setJwtToken] = useState(null);
  const logout = () => {
    localStorage.removeItem(tokenKey);
    Navigate("/");
    toast.success("Successfully logout");
  };

  const handleStorageChange = () => {
      console.log("jwtToken-->" + jwtToken);
      setJwtToken(localStorage.getItem(tokenKey));
  };

  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  const handleClick = (path) => {
    setActivePath(path);
  };

  useEffect(() => {
    if (localStorage.getItem(tokenKey)) {
      console.log("Fetching logged in user details");
      axios.get(`${BaseUrl}/auth/privileges`, {
        headers: {
          "Authorization": localStorage.getItem("$3ingT0k3n")
        }
      }).then(function (response) {
        let priv = response.data;
        Object.keys(priv).forEach(f=>{
          if(priv[f]?.key?.toLowerCase() === "dashboard" ){
            navigate("/SideBar/dashboard")
          }else if(priv[f]?.key?.toLowerCase() === "my-courses"){
            navigate("/SideBar/my-courses")
          }else if(priv[f]?.key?.toLowerCase() === "admissions"){
            navigate("/SideBar/admissions")
          }
        });
      }).catch(function (error) {
        localStorage.removeItem("$3ingT0k3n")
      });
    }
    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  setInterval(() => {
    if (jwtToken !== localStorage.getItem(tokenKey)){
      let token = localStorage.getItem(tokenKey)
      setJwtToken(token);
    }
  }, 1500);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      {jwtToken ? (
        <div
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            height: 152,
            zIndex: "10",
            borderBottom: "1px solid #cfcfcfcf",
          }}
        >
          <div
            className="text-center"
            style={{ backgroundColor: "#2f506c", color: "white" }}
          >
            {" "}
            Contact us at gjuskillcourses@hkcl.in
            <span style={{ float: "right" }}>
              {/* {jwtToken != null && <Button onClick={logout}>Logout</Button>} */}
            </span>
          </div>
          <header style={{ padding: "1% 0" }}>
            <Container>
              <div
                className="Row viewl"
                style={{ display: "flex", padding: "0 2%", margin: "0 0 0 0" }}
              >
                <div className="Col h1">
                  <img
                    src={imageUrl}
                    alt="GJUlogo"
                    style={{ width: 120, height: 110 }}
                  />
                </div>

                <div
                  className="text-center Col h2  "
                  style={{ color: "#070401", padding: "0 2%" }}
                >
                  <h4 style={{ textTransform: "uppercase" }}>
                    Guru Jambheshwar University of Science & Technology, Hisar
                  </h4>
                  <h6
                    style={{
                      textTransform: "uppercase",
                      fontSize: "15px",
                      color: "grey",
                    }}
                  >
                    (A Haryana State Government University, Accredited 'A+'
                    Grade by NAAC)
                  </h6>
                  <h6
                    style={{
                      textTransform: "uppercase",
                      fontSize: "15px",
                      color: "grey",
                    }}
                  >
                    Established by Haryana State Legislative Act No.17 of 1995 &
                    Recognised by UGC Act 1956 u/s 12-B & 2(F)
                  </h6>
                </div>
                <div
                  className="text-center Col h4  align-items-center"
                  style={{ color: "#070401", padding: "0 2%", display: "none" }}
                >
                  <h3 style={{ textTransform: "uppercase" }}>GJUST Hisar</h3>
                </div>

                <div className="Col h3 ">
                  <img
                    src={babaji}
                    alt="GJUlogo"
                    style={{ width: 120, height: 110 }}
                  />
                </div>
              </div>
            </Container>
          </header>
        </div>
      ) : (
        <div style={{ borderBottom: "1px solid grey" }}>
          <Navbar expand="md">
            <div
              className="col-md-6 col-xs-8"
              style={{ display: "flex", alignItems: "center" }}
            >
              <img
                src={imageUrl}
                alt="GJUlogo"
                style={{ width: 85, height: 75, paddingLeft: "2%" }}
              />

              <div className="h2">
                <h4 style={{ fontFamily: "Poppins" }} className=" ms-4 vm p-0">
                  Centre for Distance and Online Education
                </h4>
                <h5 style={{ fontFamily: "Poppins" }} className=" ms-4 vm">
                  Guru Jambheshwar University of Science & Technology, Hisar
                </h5>
              </div>

              <div
                className="text-center Col h4  align-items-center"
                style={{ color: "#070401", display: "none" }}
              >
                <h3 style={{ paddingLeft: "10px" }}>
                  CDOE
                  <br /> GJUS&T Hisar
                </h3>
              </div>
            </div>

            <div className="h4" style={{ display: "none" }}>
              <img
                src={babaji}
                alt="GJUlogo"
                style={{ width: 85, height: 75, paddingLeft: "2%" }}
              />
            </div>

            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav
                className="ml-auto"
                navbar
                style={{ marginLeft: "17%", fontFamily: "Open Sans" }}
              >
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/home"
                    className={`nav-link ${activePath === "/home" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/home")}
                  >
                    Home
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/about"
                    className={`nav-link ${activePath === "/about" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/about")}
                  >
                    About Us
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Coursesdetail"
                    className={`nav-link ${activePath === "/Coursesdetail" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/Coursesdetail")}
                  >
                    Courses
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/feeStructure"
                    className={`nav-link ${activePath === "/feeStructure" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/feeStructure")}
                  >
                    Fee Structure
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/faq"
                    className={`nav-link ${activePath === "/faq" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/faq")}
                  >
                    FAQ
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/login"
                    className={`nav-link ${activePath === "/login" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/login")}
                  >
                    Login
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/instructions"
                    className={`nav-link ${activePath === "/instructions" ? "active" : ""
                      }`}
                    onClick={() => handleClick("/instructions")}
                  >
                    Register 
                  </NavLink>
                </NavItem>
                
                
              </Nav>
            </Collapse>
            <div className="h2">
              <img
                src={babaji}
                alt="GJUlogo"
                style={{ width: 85, height: 75, paddingLeft: "2%" }}
              />
            </div>
          </Navbar>
        </div>
      )}
    </>
  );
};

export default Header;
